import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { red } from "./theme";
import { Grid } from "@mui/material";
import { useHistory } from "react-router-dom";


export const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface INotificationModal {
  handleModal(): void;
  msg: string | null;
  display: boolean;  err_msg: string | null;
  formErrMsg: string | null;
  formMsg: string | null;
  filesErrMsg: string | null;
  filesMsg: string | null;
}

export default function Error(props: INotificationModal) {
  const { msg, handleModal, display, err_msg, formErrMsg, formMsg, filesErrMsg, filesMsg } = props;
  const history = useHistory()

  return (
    <div>
      <Modal open={display} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <>
        <Box sx={modalStyle}>
          <Typography textAlign={"center"}>{msg ? msg : (formMsg ? formMsg : filesMsg)} </Typography>
          <Typography sx={{ color: red }} textAlign={"center"}>
            {err_msg ? err_msg : (formErrMsg ? formErrMsg : filesErrMsg)}
          </Typography>
          {msg === "Upload Successful" ? <><Typography>Would you like to submit another expense reimbursement request?</Typography>
          <Grid container justifyContent={'space-between'}>   <Button type="button" variant="contained" onClick={() => {handleModal(); history.push("/submit_expense")}} sx={{ marginTop: 5, width: "40%" }} color="primary">
            Yes
          </Button>
          <Button type="button" variant="contained" onClick={() => {handleModal(); history.push("/user_page")}} sx={{ marginTop: 5, width: "40%" }} color="primary">
            No
          </Button></Grid></> :  <Button type="button" variant="contained" onClick={handleModal} sx={{ marginTop: 5, width: "100%" }} color="primary">
            OK
          </Button>} 
         
        </Box>
        </>
      </Modal>
    </div>
  );
}
